import { Component, Input } from '@angular/core';
import { ListColumn } from '@coin/shared/core/util-models';

@Component({
  selector: 'coin-c-list-item',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  standalone: false
})
export class ListItemComponent {
  @Input() columns: ListColumn[];

  public get columnWidths(): string[] {
    return this.columns?.map(column => column.width);
  }
}
